// src/pages/Deposit/DepositPage.jsx
import { useState, useEffect } from 'react';
import CurrencySelect from './components/CurrencySelect';
import PaymentMethodSelect from './components/PaymentMethodSelect';
import DepositSummary from './components/DepositSummary';

export default function DepositPage() {
  const [amount, setAmount] = useState(500);
  const [currency, setCurrency] = useState('usd');
  const [paymentMethod, setPaymentMethod] = useState('card');
  const [processing, setProcessing] = useState(false);
  const [balance, setBalance] = useState(2450);

  const handleAmountChange = (e) => {
    const value = parseFloat(e.target.value);
    setAmount(isNaN(value) ? 0 : value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (amount < 10) {
      alert('Minimum deposit amount is $10');
      return;
    }
    
    setProcessing(true);
    
    // Simulate API call - replace with actual Stripe integration later
    setTimeout(() => {
      alert(`Processing $${amount} deposit via ${paymentMethod} in ${currency.toUpperCase()}`);
      setProcessing(false);
      // In the future, implement Stripe checkout here
    }, 1500);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-black">
      <div className="bg-zinc-900 text-white p-8 rounded-xl shadow-xl w-full max-w-md">
        <h2 className="text-2xl font-semibold text-purple-300 mb-2">Deposit Funds</h2>
        <p className="text-zinc-400 text-sm mb-6">Add funds to your trading account</p>
        
        <div className="bg-zinc-800/50 border-l-4 border-purple-500 rounded p-4 mb-6">
          <div className="font-medium text-purple-300 mb-1">Account Information</div>
          <div className="text-zinc-300">Current Balance: ${balance.toLocaleString()}</div>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-zinc-300 mb-2" htmlFor="amount">
              Deposit Amount
            </label>
            <input
              type="number"
              id="amount"
              value={amount}
              onChange={handleAmountChange}
              min="10"
              className="w-full bg-zinc-800 border border-zinc-700 text-white rounded-md px-4 py-3 focus:outline-none focus:ring-2 focus:ring-purple-500"
              placeholder="Enter amount"
            />
          </div>
          
          <PaymentMethodSelect 
            selected={paymentMethod} 
            onChange={setPaymentMethod} 
          />
          
          <CurrencySelect 
            selected={currency} 
            onChange={setCurrency} 
          />
          
          <DepositSummary 
            amount={amount} 
            fee={0} 
            total={amount} 
          />
          
          <button 
            type="submit" 
            disabled={processing}
            className={`w-full mt-6 py-3 px-4 rounded-md font-medium transition-colors ${
              processing 
                ? 'bg-purple-800 cursor-not-allowed' 
                : 'bg-purple-600 hover:bg-purple-700'
            }`}
          >
            {processing ? 'Processing...' : 'Proceed to Payment'}
          </button>
        </form>
      </div>
    </div>
  );
}
